import React from 'react'
import PropTypes from 'prop-types'

import { BoardCodeBase } from './styles'

import BoardIcon from '../RoomResponsive/OfferResponsive/Board/BoardIcon'
import { BOARD_CODE_ROOM_ONLY } from '../constants'

const BoardCode = ({ code, name }) => {
  return (
    <BoardCodeBase
      color={code === BOARD_CODE_ROOM_ONLY ? 'grey2' : 'green'}
      data-testid="board-code"
    >
      <BoardIcon code={code} />
      <p>{name}</p>
    </BoardCodeBase>
  )
}

BoardCode.propTypes = {
  code: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
}

export default BoardCode
